function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "Combined Shape");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop-view",
  stroke: "none",
  strokeWidth: 1,
  fill: "current",
  fillRule: "evenodd",
  opacity: 0.699125744
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Home-screen-pinned",
  transform: "translate(-1148.000000, -649.000000)",
  fill: "current"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(677.000000, 623.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Pin_1955636",
  transform: "translate(471.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M21,0 C22.1045695,-2.02906125e-16 23,0.8954305 23,2 L23,24.2308074 C23,25.3353769 22.1045695,26.2308074 21,26.2308074 C20.7863357,26.2308074 20.5740518,26.1965695 20.3712216,26.1293957 L12.1287784,23.3996464 C11.7204968,23.2644308 11.2795032,23.2644308 10.8712216,23.3996464 L2.62877841,26.1293957 C1.58021702,26.4766605 0.44867638,25.9081472 0.101411653,24.8595858 C0.0342379175,24.6567556 2.61663247e-17,24.4444716 0,24.2308074 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L21,0 Z M7.79280935,5.16414636 L4.1663682,8.74623075 C4.05984811,8.85138053 4,8.99403471 4,9.14278663 C4,9.29153856 4.05984811,9.43419273 4.1663682,9.53934251 C4.83330829,10.2015128 5.76913522,10.5277971 6.70911491,10.4258934 L9.03693901,13.3673588 C8.4171445,15.1217729 8.78834011,17.1161387 10.0207398,18.5356667 C10.1240874,18.6536934 10.2722959,18.7241853 10.4301523,18.730394 L10.4520986,18.730394 C10.6026958,18.730394 10.7468605,18.6720879 10.8531866,18.5666885 L13.8061026,15.6495173 L17.0314558,18.8354196 C17.1376793,18.9407754 17.2820118,19 17.4325438,19 C17.5830758,19 17.7274082,18.9407754 17.8336318,18.8354196 C17.9401519,18.7302698 18,18.5876156 18,18.4388637 C18,18.2901118 17.9401519,18.1474576 17.8336318,18.0423079 L14.6082787,14.8567793 L17.5619514,11.9403557 C17.6738204,11.8299515 17.7339867,11.6784527 17.7279531,11.5223632 C17.7219195,11.3662737 17.6502332,11.2197476 17.5301671,11.1180909 C16.1687381,9.9643039 14.298003,9.57111184 12.5812706,10.0611069 L9.49289284,7.6757915 C9.59571991,6.74734781 9.26544571,5.82310856 8.59536379,5.16414636 C8.3737249,4.94528455 8.01444824,4.94528455 7.79280935,5.16414636 Z M8.13600449,6.41099877 C8.36675466,6.83242938 8.43401981,7.32250848 8.32519696,7.78941354 C8.2766789,8.00101277 8.35611578,8.22126867 8.52914643,8.35490747 L12.1185058,11.127061 C12.2725085,11.2455419 12.4760796,11.2780588 12.6577044,11.2137726 C13.8669276,10.7907316 15.205469,10.9356362 16.2932268,11.6073384 L13.405393,14.4602235 L13.4046362,14.460971 L10.5164241,17.3131085 C9.79938463,16.1806256 9.66922022,14.739046 10.2046349,13.4910723 C10.285407,13.3036107 10.2567135,13.0876063 10.1297147,12.9270734 L7.39626195,9.47393508 C7.26078958,9.30303521 7.03771567,9.22458993 6.82338717,9.27248021 C6.35068758,9.3796935 5.8546402,9.31326454 5.42790356,9.08560186 L8.13600449,6.41099877 Z",
  id: "Combined-Shape"
})))));
const SvgFlag = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "27px",
    fill: "current",
    viewBox: "0 0 23 27",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/flag.438e8403.svg";
export { ForwardRef as ReactComponent };